import { render, staticRenderFns } from "./ViewApplicationPklWI.vue?vue&type=template&id=94793916&scoped=true&"
import script from "./ViewApplicationPklWI.vue?vue&type=script&lang=js&"
export * from "./ViewApplicationPklWI.vue?vue&type=script&lang=js&"
import style0 from "./ViewApplicationPklWI.vue?vue&type=style&index=0&id=94793916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94793916",
  null
  
)

export default component.exports